import GrComponentFactory from "../gr_component_factory";
import ShapeIcon from "../shape_icon";
import { ICON_SIZES } from "../../modules/shape_icon_values";

export default GrComponentFactory.createClass({
  displayName: "NonsocialUpdate",

  propTypes: {
    header: React.PropTypes.element.isRequired,
    body: React.PropTypes.element.isRequired,
    footer: React.PropTypes.element,
    updateIconUrl: React.PropTypes.string.isRequired,
  },

  renderIcon() {
    return <ShapeIcon imageUrl={this.props.updateIconUrl}
                      imageAlt="Goodreads"
                      size={ICON_SIZES.MEDIUM}/>;
  },

  render() {
    return (
      <div className="gr-newsfeedItem gr-mediaBox">
        <div className="gr-newsfeedItem__headerIcon gr-mediaBox__media gr-mediaBox__media--marginSmall">
          {this.renderIcon()}
        </div>
        <div className="gr-mediaBox__desc gr-newsfeedItem__body">
          <div className="gr-newsfeedItem__header gr-newsfeedItem__header--timestamp">
            {this.props.header}
          </div>
          {this.props.body}
        </div>
        <div className="gr-newsfeedItem__footer">
          {this.props.footer}
        </div>
      </div>);
  },
});
